import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../../../store/authenticationSlice";
import { AUTH_TOKEN } from "../../../constants/message";
import { encode } from "../../../utils/hashString";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../../lib/axios";
import {
  MERCHANT_LOGIN,
  MERCHANT_USER_FIND_BY_TOKEN,
} from "../../../lib/endpoints/merchants";

export const useLoginController = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { t } = useTranslation("global");

  const [isForgotPasswordPage, setIsForgotPasswordPage] =
    useState<boolean>(false);
  const [openSignUpForm, setOpenSignUpForm] = useState<boolean>(false);

  const [errorMessage, setErrorMessage] = useState<string>("");
  const [loggingIn, setLoggingIn] = useState<boolean>(false);

  const username = useRef<HTMLInputElement>(null!);
  const password = useRef<HTMLInputElement>(null!);

  const handleOpenIsForgotPasswordPage = () => {
    setIsForgotPasswordPage(true);
  };

  const handleCloseIsForgotPasswordPage = () => {
    setIsForgotPasswordPage(false);
  };

  const onSubmit = async (e: any) => {
    e.preventDefault();
    try {
      setLoggingIn(true);
      const { data } = await axios.post(MERCHANT_LOGIN, {
        username: username.current.value,
        password: password.current.value,
      });

      const token: string = data?.data?.token;
      axios.defaults.headers.common["Authorization"] = token;
      axiosInstance.defaults.headers.common["Authorization"] = token;
      const { data: dataMerchant } = await axios.get(
        MERCHANT_USER_FIND_BY_TOKEN
      );

      console.log(dataMerchant?.merchant);
      if (!dataMerchant?.merchant) {
        setErrorMessage(t("ບໍ່ສາມາດເຂົ້າບັນຊີນີ້ໄດ້ເພາະບໍ່ພົບສາຂາກະລຸນາລອງບັນຊີອື່ນ") || "");
        return;
      }


      dispatch(loginSuccess(dataMerchant));
      localStorage.setItem(
        AUTH_TOKEN,
        JSON.stringify({
          accessToken: encode(token),
          // refreshToken: encode(dataRefreshToken?.refreshToken),
        })
      );
      navigate("/");
    } catch (err: any) {
      console.log("error=", err);
      if (err?.response?.data?.message) {
        setErrorMessage(err?.response?.data?.message);
      } else {
        setErrorMessage(t("Server error please try again") || "");
      }
    } finally {
      setLoggingIn(false);
    }
  };

  return {
    onSubmit,
    username,
    password,
    errorMessage,
    loggingIn,
    isForgotPasswordPage,
    handleOpenIsForgotPasswordPage,
    handleCloseIsForgotPasswordPage,
    handleOpenRegisterMerchant: () => setOpenSignUpForm(true),
    handleCloseRegisterMerchant: () => setOpenSignUpForm(false),
    openSignUpForm,
  };
};
